module.exports = __webpack_public_path__ + "static/img/1-2.2b3c4cd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/99/1-2.png
// module id = WvRQ
// module chunks = 0